import React from 'react';
import { observer } from 'mobx-react';
import { Formik, useFormikContext } from 'formik';

import { DocumentViewMode } from 'containers/Tiptap/components/tiptap-extension/document-settings-yjs';
import { TabComponentProps } from '../EntityDetailsContent/types';

import PreviewPane from './PreviewPane';
import RemoteSettingsObserver from './RemoteSettingsObserver';
import SettingsDirtySync from './SettingsDirtySync';
import SettingsFormActions from './SettingsFormActions';
import ViewModeFlipModal from './ViewModeFlipModal';
import LayoutSection from './sections/LayoutSection';
import { FormColumn, PageGrid, Sections, SettingsForm, StatusBanner } from './styles';
import { DocumentSettingsFormValues } from './types';
import { useDocumentSettingsForm } from './useDocumentSettingsForm';
import { documentSettingsValidationSchema } from './validation';

const StatusBannerSlot: React.FC = () => {
  const { status } = useFormikContext<DocumentSettingsFormValues>();
  if (!status) return null;
  return <StatusBanner role="alert">{status}</StatusBanner>;
};

const DocumentSettingsTab: React.FunctionComponent<TabComponentProps> = () => {
  const { initialValues, handleSubmit, pendingFlip, confirmFlip, cancelFlip } = useDocumentSettingsForm();

  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={documentSettingsValidationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        <SettingsForm noValidate>
          <SettingsDirtySync />
          <RemoteSettingsObserver />
          <PageGrid>
            <FormColumn>
              <Sections>
                <StatusBannerSlot />
                <LayoutSection />
              </Sections>
            </FormColumn>
            <PreviewPane />
            <SettingsFormActions />
          </PageGrid>
        </SettingsForm>
      </Formik>
      <ViewModeFlipModal
        open={Boolean(pendingFlip)}
        toPages={pendingFlip?.values.viewMode === DocumentViewMode.Pages}
        onConfirm={confirmFlip}
        onCancel={cancelFlip}
      />
    </>
  );
};

export default observer(DocumentSettingsTab);
